module.exports = __webpack_public_path__ + "static/img/create_receipt.e989cc92.svg";